import {DoNotSellItem} from "@/api/modules/doNotSellList/DoNotSellItem";
import {DoNotSellListService} from "@/api/modules/doNotSellList/services/DoNotSellListService";
import {Session} from "@/api/common/Session";

export class DoNotSellListModule {

    constructor(auth){

        if (auth == null){
            this._auth = Session.get("auth");
        }
        else{
            this._auth = auth;
        }

        if (this._auth == null){

            throw new Error("[e651471] Auth token not found or not provided.");
        }

        this.service = new DoNotSellListService(this._auth);
    }


    getList(){
        return new Promise((resolve, reject) => {
            try{
                 this.service.getList().then(data =>{

                     if (data == null){
                         data = [];
                     }

                     let list = [];

                     data.forEach(function(partNumber){
                         if (partNumber == null || partNumber.length == 0){
                             return;
                         }

                         let obj = new DoNotSellItem(partNumber);
                         list.push(obj);
                     });

                     resolve(list);

                 }).catch(e => {
                     window.tracer.error("[e559692] Error getting the list from the service.");
                     if (e != null) {
                         window.tracer.error(e);
                     }

                     reject(e);
                 });
            }
            catch(e){

                window.tracer.error("[e276735] Error while getting the DoNotList list")
                window.tracer.error(e);
                reject(e);
            }

        });
    }

    saveItem(partNumber){

        return new Promise((resolve, reject) => {
            try{
                this.service.saveItem(partNumber).then(() =>{
                    resolve();
                }).catch(e => {
                    window.tracer.error("[e365750] Service error while saving the part number.");
                    if (e != null) {
                        window.tracer.error(e);
                    }

                    reject(e);
                });
            }
            catch(e){

                window.tracer.error("[e276735] General Error when saving the part number")
                window.tracer.error(e);
                reject(e);
            }

        });
    }

    deleteItem(partNumber){

        return new Promise((resolve, reject) => {
            try{

                this.service.deleteItem(partNumber).then(() =>{
                    resolve();
                }).catch(e => {
                    window.tracer.error("[e542828] Service error while deleting the part number.");
                    if (e != null) {
                        window.tracer.error(e);
                    }

                    reject(e);
                });
            }
            catch(e){

                window.tracer.error("[e673713] General Error when saving the part number")
                window.tracer.error(e);
                reject(e);
            }

        });

    }

}